<template>
  <div class="container">
    <!-- 当前套餐结余 -->
    <div class="caption">当前套餐结余</div>
    <div class="content">
      <section>
        <div class="title">小麦助教标准版<span class="date">{{1533028769663 | formatDate('YYYY/MM/DD')}} 购买</span></div>
        <div class="info">
          <p class="expire-date">有效期：<span class="date">2018/07/09-2019/07/10</span></p>
          <p class="order-type">购买单价：￥{{3980 | moneyFormatGroup(2)}}</p>
          <p class="order-duration">剩余时长：60天</p>
          <p class="order-duration">折合金额：￥{{5810 | moneyFormatGroup(2)}}</p>
        </div>
      </section>
      <section>
        <div class="title">小麦助教标准版<span class="date">{{1533028769663 | formatDate('YYYY/MM/DD')}} 购买</span></div>
        <div class="info">
          <p class="expire-date">有效期：<span class="date">2018/07/09-2019/07/10</span></p>
          <p class="order-type">购买单价：￥{{3980 | moneyFormatGroup(2)}}</p>
          <p class="order-duration">剩余时长：60天</p>
          <p class="order-duration">折合金额：￥{{5810 | moneyFormatGroup(2)}}</p>
        </div>
      </section>
      <div class="summary">合计 <span class="price">￥{{4479 | moneyFormatGroup(2)}}</span></div>
    </div>
    <!-- 升级套餐费用 -->
    <div class="caption">升级套餐费用</div>
    <div class="content">
      <section>
        <div class="title">小麦助教标准版<span class="date">{{1533028769663 | formatDate('YYYY/MM/DD')}} 购买</span></div>
        <div class="info">
          <p class="expire-date">有效期：<span class="date">2018/07/09-2019/07/10</span></p>
          <p class="order-type">购买单价：￥{{3980 | moneyFormatGroup(2)}}</p>
          <p class="order-duration">剩余时长：60天</p>
          <p class="order-duration">折合金额：￥{{5810 | moneyFormatGroup(2)}}</p>
        </div>
      </section>
      <div class="summary">差价 <span class="price">￥{{4479 | moneyFormatGroup(2)}}</span></div>
    </div>
    <!-- 购买须知 -->
    <div class="instruction-link">购买须知</div>
    <!-- 去结算 -->
    <div class="settlement">
      <div class="btn-settlement">去结算</div>
      <div class="account">
        <div class="amount">合计金额  <span class="price">￥{{2388 | moneyFormatGroup(2)}}</span></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data(){
    return {}
  }
}
</script>
<style lang="less" scoped>
.container{
  padding-bottom: 1.6rem;
  text-align: left;
  overflow: auto;
  height: 100%;
  .caption{
    color: #909090;
    padding: 0.2rem 0.3rem;
    font-size: 0.26rem;
  }
  .content{
    section{
      margin-bottom: 0;
      padding: 0.2rem 0.3rem;
      border-bottom: 1px solid #fafafa;
    }
    .title{
      position: relative;
      font-size: 0.34rem;
      font-weight: bold;
      .date{
        position: absolute;
        bottom: 0.05rem;
        right: 0rem;
        color: #999;
        font-size: 0.26rem;
        font-weight: normal;
      }
    }
    .info{
      margin-top: 0.2rem;
      p{
        font-size: 0.26rem;
        line-height: 0.48rem;
        .date{
          font-size: 0.26rem;
        }
      }
    }
    background-color: #fff;
    .summary{
      text-align: right;
      padding: 0.24rem 0.32rem;
      .price{
        color: #ff8534;
      }
    }
  }
  .instruction-link {
    margin-top: 0.4rem;
    text-align: center;
    font-size: 0.26rem;
    color: #999;
  }
  .settlement{
    position: fixed;
    width: 100%;
    text-align: left;
    bottom: 0;
    left: 0;
    background-color: #fff;
    .account{
      padding: 0.24rem 0.32rem;
      height: 0.9rem;
      .amount{
        font-size: 0.3rem;
        font-weight: 500;
        .price{
          color:#ff8534;
        }
      }
      .discount-amount{
        font-size: 0.2rem;
        color: #999;
      }
    }
    .btn-settlement{
      float: right;
      width: 2.4rem;
      height: 0.9rem;
      text-align: center;
      line-height: 0.9rem;
      color: #fff;
      font-size: 0.3rem;
      background: -webkit-linear-gradient(left, #FFAB1A , #ff8534); /* Safari 5.1 - 6.0 */
      background: -o-linear-gradient(right, #FFAB1A, #ff8534); /* Opera 11.1 - 12.0 */
      background: -moz-linear-gradient(right, #FFAB1A, #ff8534); /* Firefox 3.6 - 15 */
      background: linear-gradient(to right, #FFAB1A , #ff8534); /* 标准的语法 */
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/module/renew/upgrade.vue